module.exports = __webpack_public_path__ + "img/header__logo.7ec0bdf2.jpg";